import $ from 'jquery'
import axios from 'axios'
import axiosRetry from 'axios-retry'
import _ from 'lodash'
import { createAlert, scrollTo } from 'dom/window'
import Numeral from 'numeral'
import moment from 'moment'

/**
 * New Stock On Hand (SOH) logic
 *
 * Core Product Logic:
 * ** IF Product SoldAt `All` or matches Customer WAREHOUSE
 * ** example: SoldAt value could be `All` or `Sydney\Melbourne`
 *
 * SOH Logic:
 * ** IF Core Product, Use Customer WAREHOUSE to find SOH
 * ** IF NON-CORE Product, Use Customer warehouse to find SOH, and fall back to MELBOURNE warehouse
 *
 */
export const isCoreProduct = (warehouseCode = 'Melbourne', soldAt = 'ALL') => {
  return false

  /**
   * temporarily remove logic below
   */

  const checkWarehouseCode = new RegExp(warehouseCode, 'i')
  /**
   * soldAt: 'All', 'Melbourne/Sydney'
   * warehouseCode: 'SYDNEY', 'MELBOURNE', 'ADELAIDE'
   */
  if (soldAt.toUpperCase() === 'ALL' || checkWarehouseCode.test(soldAt)) {
    return true
  }

  return false
}

export const getlongtermOOS = (list, isCore = false, warehouseCode = 'Melbourne', sohRaw) => {
  const defaultSOH = warehouseMapping(warehouseCode, sohRaw)
  let newList = []
  var todayDate = moment()
  list.map((item, index) => {
    const node = item?.node ? item?.node : item
    const { Date, Location } = node?.[0] || node

    // if (!todayDate.isAfter(Date)) {
    //   console.log('Date is future')
    // } else {
    //   console.log('Date is not future')
    // }
    let data = {
      date: moment(Date).format('DD/MM/YYYY'),
      location: Location,
      isFutureDate: todayDate.diff(Date) <= 0,
    }
    newList.push(data)
  })
  if (defaultSOH == 0) {
    return newList
  }
  return null
}

export const getSOH = (
  isCore = false,
  warehouseCode = 'Melbourne',
  sohRaw,
  isCoreRange = false,
  translationRedemptionID = 0
) => {
  const defaultSOH = warehouseMapping(warehouseCode, sohRaw, isCoreRange, translationRedemptionID)
  return defaultSOH

  /**
   * temporarily remove logic below
   */

  if (isCore) {
    return defaultSOH
  }

  if (!isCore && defaultSOH === 0) {
    return warehouseMapping('MELBOURNE', sohRaw)
  }

  return defaultSOH
}

const warehouseMapping = (warehouseCode, sohRaw, isCoreRange = false, translationRedemptionID = 0) => {
  const code = warehouseCode.toUpperCase()
  /**
   * If SOH is negative, go into 0.
   * If the warehouseCode is not exist, fall back to StockForMelbourne
   * TranslationRedemptionID = 9907276 represents experiences in Evolution Rewards and we show combinedStock for this
   */
  if (
    translationRedemptionID == '9907276' &&
    !sohRaw?.['vic'] &&
    !sohRaw?.['nsw'] &&
    !sohRaw?.['sa'] &&
    !sohRaw?.['qld'] &&
    !sohRaw?.['wa']
  ) {
    return Math.max(0, sohRaw?.['all'])
  }

  if (code === 'MELBOURNE') return Math.max(0, sohRaw?.['vic'])
  if (code === 'SYDNEY') return Math.max(0, sohRaw?.['nsw'])
  if (code === 'ADELAIDE') return Math.max(0, sohRaw?.['sa'])
  if (code === 'BRISBANE') return Math.max(0, sohRaw?.['qld'])
  if (isCoreRange && code === 'CAIRNS') return Math.max(0, sohRaw?.['qld'])
  if (code === 'CAIRNS') return Math.max(0, sohRaw?.['wa'])

  return Math.max(0, sohRaw?.['vic'])
}

// localStorage
export const storageAvailable = (type) => {
  try {
    var storage = window[type]
    const x = '__storage_test__'
    storage.setItem(x, x)
    storage.removeItem(x)
    return true
  } catch (e) {
    return (
      e instanceof DOMException &&
      // everything except Firefox
      (e.code === 22 ||
        // Firefox
        e.code === 1014 ||
        // test name field too, because code might not be present
        // everything except Firefox
        e.name === 'QuotaExceededError' ||
        // Firefox
        e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
      // acknowledge QuotaExceededError only if there's something already stored
      storage.length !== 0
    )
  }
}

// converters
export const convertToBoolean = (string) => {
  if (typeof string === 'boolean') return string
  if (typeof string === 'number') return Boolean(string)
  if (typeof string === 'string' && string.length === 1) return Boolean(Number(string))
  if (typeof string === 'string' && string.length !== 1) return string.toLowerCase() === 'true'
  return false
}

// scroll to hash
export const scrollToLocationHash = () => {
  if (location.hash) {
    const $targetElement = $(location.hash)

    if ($targetElement.length) {
      scrollTo($targetElement)
    }
  }
}

// fetch
export const param = (a) => {
  const s = []
  const add = function (k, v) {
    v = typeof v === 'function' ? v() : v
    v = v === null ? '' : v === undefined ? '' : v
    s[s.length] = encodeURIComponent(k) + '=' + encodeURIComponent(v)
  }
  var buildParams = function (prefix, obj) {
    let i, len, key

    if (prefix) {
      if (Array.isArray(obj)) {
        for (i = 0, len = obj.length; i < len; i++) {
          buildParams(prefix + '[' + (typeof obj[i] === 'object' && obj[i] ? i : '') + ']', obj[i])
        }
      } else if (String(obj) === '[object Object]') {
        for (key in obj) {
          buildParams(prefix + '[' + key + ']', obj[key])
        }
      } else {
        add(prefix, obj)
      }
    } else if (Array.isArray(obj)) {
      for (i = 0, len = obj.length; i < len; i++) {
        add(obj[i].name, obj[i].value)
      }
    } else {
      for (key in obj) {
        buildParams(key, obj[key])
      }
    }
    return s
  }
  return buildParams('', a).join('&')
}
export const getFormData = (object) => {
  const formData = new FormData()
  Object.keys(object).forEach((key) => formData.append(key, object[key]))
  return formData
}
export const handleFetchErrors = (response) => {
  if (!response.ok) {
    throw Error(response.statusText)
  }
  return response
}
export const fetchJSONData = (url, config, data, callback) => {
  const defaultConfig = {
    method: 'POST',
    body: param(data), // body: getFormData(data),
    credentials: 'include',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    },
  }
  fetch(url, {
    ...defaultConfig,
    ...config,
  })
    .then(handleFetchErrors)
    .catch((error) => console.error('Error:', error))
    .then((res) => res.json())
    .then(callback)
}

// axios
export const handleAuthenticationRequired = (message) => {
  $('#unauthorized-access-modal').modal('show')
}
export const handleErrorMessage = (message) => {
  if (
    message &&
    (message.toLowerCase() == 'authentication required' ||
      message.toLowerCase() == 'unauthorized access' ||
      message.toLowerCase() == 'access denied' ||
      message.toLowerCase() == 'access forbidden')
  ) {
    handleAuthenticationRequired(message)
    return true
  }
  return false
}
export const handleAxiosErrors = (error) => {
  if (axios.isCancel(error)) {
    return
  }

  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    console.log(error.response.data)
    console.log(error.response.status)
    console.log(error.response.headers)
  } else if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    console.log(error.message, error.request)
    if (handleErrorMessage(error.message)) return
  } else {
    // Something happened in setting up the request that triggered an Error
    console.log(error.message)
    if (handleErrorMessage(error.message)) return
  }

  if (typeof error.message !== 'undefined') {
    createAlert({ message: error.message }, 'error')
  } else {
    createAlert({}, 'error')
  }
  // console.log(error.config);
}
export const axiosInstance = axios.create({
  withCredentials: true,
})

axiosRetry(axiosInstance, {
  retries: 3, // number of retries
  retryDelay: (retryCount) => {
    return retryCount * 2000 // time interval between retries
  },
  retryCondition: (error) => {
    // if retry condition is not specified, by default idempotent requests are retried
    return error.response.status >= 500
  },
})

axiosInstance.interceptors.response.use((response) => {
  if (response.data.errors) {
    throw response.data.errors[0]
  } else if (typeof response.data.status !== 'undefined' && response.data.status == 0) {
    throw response.data
  }
  return response
})
export const createAxiosCancellationToken = () => {
  return axios.CancelToken.source()
}

// search server helper
export const sanitizeInput = (keyword) => {
  return keyword.replace(/([<>?"';:!@#$%^&*()\-=+[\]{}|`~,])*/gi, '')
}

// number helper
export const countDecimals = (value) => {
  if (typeof value === 'string') {
    value = Number(value)
  }

  if (Math.floor(value) === value) return 0
  return value.toString().split('.')[1].length || 0
}
export const floorToTwoDecimals = (value = 0) => {
  if (countDecimals(value) > 2) {
    value = Math.floor(value * 100) / 100
  }

  return value
}

// break list into multiple chunks
export const breakListIntoChunks = (list, requestMaximumChunk) => {
  return list.reduce((resultArray, item, index) => {
    const chunkIndex = Math.floor(index / requestMaximumChunk)

    if (!resultArray[chunkIndex]) {
      resultArray[chunkIndex] = [] // start a new chunk
    }

    resultArray[chunkIndex].push(item)

    return resultArray
  }, [])
}

// check empty
export const checkEmptyOnList = (data, keyList) => {
  let validationStatus = true

  keyList.map((key) => {
    if (!checkEmpty(data[key])) {
      validationStatus = false
    }
    return key
  })

  return validationStatus
}
export const checkEmpty = (variable) => {
  if (typeof variable === 'undefined') {
    return false
  }

  if (typeof variable === 'string' && variable.length <= 0) {
    return false
  }

  if (Array.isArray(variable) && variable.length <= 0) {
    return false
  }

  if (variable == null) {
    return false
  }

  return true
}
export const getEmptyImage = () => {
  return 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAADICAYAAABS39xVAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4wcDATofVfIJyQAAABl0RVh0Q29tbWVudABDcmVhdGVkIHdpdGggR0lNUFeBDhcAAAD9SURBVHja7cEBAQAAAICQ/q/uCAoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKp1AAEU6coPAAAAAElFTkSuQmCC'
}
export const ucwords = (text) => {
  text = text.toLowerCase()
  return text.replace(/(^([a-zA-Z\p{M}]))|([ -][a-zA-Z\p{M}])/g, function (s) {
    return s.toUpperCase()
  })
}

/**
 * Exclude supplier points and bonus points for Retail Customers
 *
 * BE logic:
 * var pointsExcludedFromRetail = <% if $CurrentMember && $CurrentMember.isExcludedFromRetailGroups %>true<% else %>false<% end_if %>;
 * If pointsExcludedFromRetail = true and Product->PointsExcludedFromRetail = true
 * then exclude the point from retail
 */
export const excludeFromRetail = (pointsExcludedFromRetail = false) => {
  const templatePointsExcludedFromRetail = window?.pointsExcludedFromRetail || false

  if (templatePointsExcludedFromRetail && pointsExcludedFromRetail) {
    return true
  }

  return false
}

export const debounceDispatchFunction = _.debounce((dispatch, action, extra, data) => {
  dispatch(action(extra, data))
}, 2000)

export const initiatePaymentJS = (handleNewFormUpdate = null) => {
  if (!PaymentJs) {
    console.error('PaymentJs is not set')
  }

  let tillpaymentKey = window?.tillPaymentToken || 'u5nA8DXkvHmHyYzrwdIz' // test key, for staging

  const inputStyle = {
    border: 'none',
    outline: 'none',
    height: '100%',
    padding: '0px',
  }

  let payment = new PaymentJs()

  payment.init(tillpaymentKey, 'number_div', 'cvv_div', (payment) => {
    payment.setNumberStyle(inputStyle)
    payment.setCvvStyle(inputStyle)

    payment.numberOn('input', (data) => {
      const { validNumber } = data

      handleNewFormUpdate('validNumber', validNumber)
    })

    payment.cvvOn('input', (data) => {
      const { validCvv, cvvLength } = data

      // there has a library bug on validCvv
      // handleNewFormUpdate('validCvv', validCvv)
      handleNewFormUpdate('cvvLength', cvvLength)
    })
  })

  return payment
}

export const allowOnlyNumericInput = (value) => {
  return value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1')
}

export const isEmpty = (object) => {
  const res = Object.values(object).some((x) => x === null || x === '')
  return res
}

export const objectEquals = (x, y) => {
  if (isEmpty(x) || isEmpty(y)) return false
  if (x === y) return true
  // if both x and y are null or undefined and exactly the same

  if (!(x instanceof Object) || !(y instanceof Object)) return false
  // if they are not strictly equal, they both need to be Objects

  if (x.constructor !== y.constructor) return false
  // they must have the exact same prototype chain, the closest we can do is
  // test there constructor.

  for (var p in x) {
    if (!x.hasOwnProperty(p)) continue
    // other properties were tested using x.constructor === y.constructor

    if (!y.hasOwnProperty(p)) return false
    // allows to compare x[ p ] and y[ p ] when set to undefined

    if (x[p] === y[p]) continue
    // if they have the same strict value or identity then they are equal

    if (typeof x[p] !== 'object') return false
    // Numbers, Strings, Functions, Booleans must be strictly equal

    if (!objectEquals(x[p], y[p])) return false
    // Objects and Arrays must be tested recursively
  }

  for (p in y) if (y.hasOwnProperty(p) && !x.hasOwnProperty(p)) return false
  // allows x[ p ] to be set to undefined

  return true
}

export const getCoreRange = (locationID = 0, coreRange = false) => {
  // Get the relevant values from local storage or use default values
  const currentCustomerLocationID = JSON.parse(localStorage.getItem('currentCustomerLocationID')) || 0
  const currentMemberLocationID = JSON.parse(localStorage.getItem('currentMemberLocationID')) || 0
  const is3plActive = JSON.parse(localStorage.getItem('is3plActive')) || false

  // Check if the current customer location is 6(Cairns)  and 3PL is active
  const isCustomerLocation6 = is3plActive && currentCustomerLocationID == 6

  // Check if the current member location is 5(Cairns) and 3PL is not active
  const isMemberLocation5 = !is3plActive && currentMemberLocationID == 5

  // Check if there is no supplier ID and the location is 5(Cairns)
  const isLocation5WithoutSupplier = !window.supplierID && locationID == 5

  // Determine if the core range is applicable based on the conditions
  const isCoreRangeApplicable = isCustomerLocation6 || isMemberLocation5 || isLocation5WithoutSupplier

  // Return the core range value if applicable, otherwise return false
  return isCoreRangeApplicable ? coreRange : false
}

export const locationsWithIds = [
  { id: 1, location: 'default' },
  { id: 2, location: 'MELBOURNE' },
  { id: 3, location: 'SYDNEY' },
  { id: 4, location: 'ADELAIDE' },
  { id: 5, location: 'BRISBANE' },
  { id: 6, location: 'CAIRNS' },
]

//Prepod
export const imageBaseUrl = 'https://assets.paramountliquor.com.au'

//Live
// export const imageBaseUrl = 'https://www.paramountliquor.com.au'
